import type { Winner } from '../types/bingo-events/in/backend/winner-message';

export const ticketCardId = (id: string | number) =>
    String(id).split('-').pop()!;

export const mergeConfirmedWins = (
    previous: readonly Winner[],
    incoming: readonly Winner[]
) => {
    const records = new Map<string, Winner>();
    for (const winner of [...previous, ...incoming]) {
        const key = JSON.stringify([
            String(winner.userId),
            ticketCardId(winner.cardId),
            winner.part,
        ]);
        records.set(key, winner);
    }
    return [...records.values()];
};
